import {ApiService} from "./api.service";
import {AuthenticationResponse, User, UserGroup} from "@icure/api";
import {Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {Credentials} from "../models/credentials.model";
import {setAuthenticationProvider} from "../authentication/authenticationProviderCache";
import {JwtAuthenticationProvider} from "@icure/api/icc-x-api/auth/AuthenticationProvider";
import {JwtAuthService} from "@icure/api/icc-x-api/auth/JwtAuthService";
import {AuthenticationManagementService} from "./authenticationManagement.service";
import {Logout} from "../actions/authentication.actions";
import {Store} from "@ngxs/store";

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {

  constructor(
    private api: ApiService,
    private router: Router,
    private store: Store,
    private authenticationManagementService: AuthenticationManagementService,
  ) {
  }

  public async getCurrentUser(){
    return this.api.userApi!!.getCurrentUser().then((user: User) => {
      return user;
    });
  }

  public async login(credentials: Credentials){
    return await this.authenticationManagementService.initializeAndConfigureIcureBasicApi(credentials);
  }

  async logout(cleanup = false): Promise<void> {
    const user = await this.api.userApi?.getCurrentUser();
    if (!user?.id) return;
    sessionStorage.clear()
    await this.store.dispatch(new Logout()).toPromise();
    await this.api.authApi.logout()
  }

}
